import React, { useState, useEffect, useContext } from "react";
//Material ui core
import { CssBaseline, useMediaQuery } from "@material-ui/core";
//Components
import Header from "./Header/Header";
import DrawerComp from "./DrawerComp";
//utils
import { useNavigationStyles } from "../../Util/CSS/NavigationStyles";
import clsx from "clsx";
import Routes from "../../Util/Routes/Routes";
import AuthRoutes from "../../Util/Routes/AuthRoutes";
import { useTheme } from "@material-ui/core/styles";
import { withRouter, BrowserRouter } from "react-router-dom";
import { AuthContext } from "../../Context/Auth";
import { RestaurantContext } from "../../Context/RestaurantData";

import Fallback from "../../Shared/Fallback";
import { ErrorBoundary } from "react-error-boundary";

const Navigation = ({ history }) => {
  const [activationStatus, setActivationStatus] = useState(true);
  const { user } = useContext(AuthContext);
  const [baseRoute, setBaseRoute] = useState("/v1");
  const { restaurantData } = useContext(RestaurantContext);
  console.log("restDataApp.js", restaurantData);
  console.log("restDatauser", user);
  const classes = useNavigationStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleActivationState = (actState) => {
    setActivationStatus(actState);
  };
  console.log();
  console.log("state..", activationStatus);

  useEffect(() => {
    let openVal = isMobile ? false : true;
    setOpen(openVal);
  }, [isMobile]);
  useEffect(() => {
    const online = window.navigator.onLine;
    if (!online) {
      return;
    } else if (
      errorMessage.trim() === "Failed to fetch" ||
      errorMessage.trim() === "Something went wrong!!"
    ) {
      autoReload();
      setErrorMessage("");
    }
  }, [errorMessage]);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const onError = (error, errorInfo) => {
    if (
      !localStorage.getItem("apikey") &&
      localStorage.length < 2 &&
      "just" &&
      window.navigator.onLine
    ) {
      setErrorMessage(
        "Your session has been expired! Please reload to create new."
      );
    } else {
      setErrorMessage(error.message);
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; "); // Split cookies into individual name=value pairs
    for (let cookie of cookies) {
      const [key, value] = cookie.split("="); // Split each pair into a name and value
      if (key === name) {
        return decodeURIComponent(value); // Return the decoded value of the cookie
      }
    }
    return null; // Return null if the cookie is not found
  }
  let version = getCookie("version");
  if (!version) {
    document.cookie = `version=v1; path=/`;
  }
  const autoReload = () => {
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <BrowserRouter >
        {user ? (
          <>
            {!activationStatus && (
              <div className={classes.activationNotification}>
                Your restaurant is not activated yet, please contact admin to
                activate it
              </div>
            )}

            <Header
              classes={classes}
              open={open}
              handleDrawerOpen={handleDrawerOpen}
              isMobile={isMobile}
              handleActivationState={handleActivationState}
              activationStatus={activationStatus}
            />

            <DrawerComp
              classes={classes}
              open={open}
              handleDrawerClose={handleDrawerClose}
              isMobile={isMobile}
              activationStatus={activationStatus}
            />
            <ErrorBoundary
              fallback={<Fallback error={errorMessage} />}
              onError={onError}
            >
              <main
                className={clsx(
                  classes.content,
                  !activationStatus && classes.mt20
                )}
              >
                <div className={classes.toolbar} />
                <div className={classes.routeMargin}>
                  <Routes />
                </div>
              </main>
            </ErrorBoundary>
          </>
        ) : (
          <main className={classes.loginMain}>
            <AuthRoutes />
          </main>
        )}
      </BrowserRouter>
    </div>
  );
};

export default withRouter(Navigation);
